// import { DASHBOARD_URL } from '../../constants'
import "./style.scss"

import { Link } from "gatsby"
import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { hooks, ttf } from "tf-checkout-react"

import Logo from "../../assets/images/clickpass/main-logo.png"
import { ENV } from "../../constants/env"
import LanguageSwitcher from "../../i18n/LanguageSwitcher"

// Kept for old inbound integrations that still refer to this cookie name.
export const X_TF_ECOMMERCE = "X-TF-ECOMMERCE"

const Header = ({ setShowLogin }) => {
  const { t } = useTranslation("nav")
  const { isAuthenticated } = hooks.useAuthSession()
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const [showCopiedNotification, setShowCopiedNotification] = useState(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false)
  const isWindowDefined = useRef(typeof window !== "undefined")

  const handleLogout = async () => {
    if (isLoggingOut) return

    setIsLoggingOut(true)

    try {
      await ttf.auth.logout()
    } finally {
      if (isWindowDefined.current) {
        window.localStorage.removeItem("user_data")
        window.location.replace("/")
      } else {
        setIsLoggingOut(false)
      }
    }
  }

  const handleCopyEmail = async () => {
    if (isWindowDefined.current) {
      try {
        await navigator.clipboard.writeText(ENV.HELP_EMAIL)
        setShowCopiedNotification(true)
        setTimeout(() => setShowCopiedNotification(false), 2000)
      } catch (err) {
        console.error("Failed to copy email:", err)
      }
    }
  }

  const toggleNavigation = () => {
    const next = !isNavExpanded
    setIsNavExpanded(next)
    if (typeof document !== "undefined") {
      document.body.style.overflow = next ? "hidden" : "visible"
    }
  }

  return (
    <div className="header">
      <div className="header-container">
        <div className="logo-container">
          <Link to="/">
            <img src={Logo} alt={t("logoAlt")} height={58} width="100%" />
          </Link>
        </div>
        <nav className="nav">
          <div className={isNavExpanded ? "nav-menu expanded" : "nav-menu"}>
            <button
              type="button"
              className="hamburger"
              onClick={toggleNavigation}
              aria-label={t("toggleNavigation")}
            >
              {isNavExpanded ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              ) : (
                <svg viewBox="0 0 100 80" width="80" height="20">
                  <rect width="80" height="10" rx="8" />
                  <rect y="30" width="80" height="10" rx="8" />
                  <rect y="60" width="80" height="10" rx="8" />
                </svg>
              )}
            </button>
            <ul>
              <li>
                <button
                  type="button"
                  className="nav-button"
                  onClick={handleCopyEmail}
                  // The address is the widest thing in the bar, so it drops out
                  // on narrower screens (see style.scss). Keep it on the title
                  // and the accessible name so nothing is actually lost — and
                  // the click still copies it either way.
                  title={t("contact", { email: ENV.HELP_EMAIL })}
                  aria-label={t("contact", { email: ENV.HELP_EMAIL })}
                >
                  {t("contactLabel")}{" "}
                  <span className="nav-contact-email">{ENV.HELP_EMAIL}</span>
                  {showCopiedNotification && (
                    <span className="copied-notification">{t("common:emailCopied")}</span>
                  )}
                </button>
              </li>
              {isAuthenticated ? (
                <>
                  <li>
                    <Link className="nav-button" to="/orders">
                      {t("myTickets")}
                    </Link>
                  </li>
                  <li>
                    <button
                      aria-busy={isLoggingOut}
                      className="nav-button"
                      disabled={isLoggingOut}
                      onClick={handleLogout}
                      type="button"
                    >
                      {t("logOut")}
                    </button>
                  </li>
                </>
              ) : (
                <li>
                  <div className="nav-button">
                    <button
                      type="button"
                      onClick={() => {
                        setShowLogin(true)
                        setIsNavExpanded(false)
                      }}
                    >
                      {t("logIn")}
                    </button>
                  </div>
                </li>
              )}
              <li className="nav-language">
                <LanguageSwitcher />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Header
